import React from "react";
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Button, Modal, Radio, DatePicker, Input } from 'antd';
import FadeLoader from 'react-spinners/FadeLoader';
import { Line, Scatter } from 'react-chartjs-2';

import { getHistoryData } from 'middleware/data/actions';
import { updateFamilyItem } from 'middleware/family/actions';
import {
  deviceName, constructRoomDetailStatus, genderText,
  getGraphTitle, getDeviceData, constructGraphData,
  gender, constructFinalData, minDate, lineChartPlugin,
  scatterChartPlugin,
} from 'modules/room';
import {
  roomDetailDialog as roomDetailDialogStrings,
  roomEditDialog as roomEditDialogStrings,
  roomItem as roomItemStrings,
} from 'ui/constants/strings';

import ButtonTile from './buttomTile';
import InfoTile from './infoTile';

const styles = {
  roomDetailDialog: {
    borderRadius: 0,
  },
  roomEditDialog: {
    borderRadius: 0,
  },
  topDiv: {
    height: 50,
    lineHeight: '45px',
  },
  nullScreenContainer: {
    width: 760,
    height: 580,
    color: '#D2D2D2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 50,
    fontWeight: 600,
  }
}

const initialRoomEditState = {
  roomEditVisible: false,
  roomEditGender: gender.male,
  roomEditPatient: '',
  roomEditBirthday: undefined,
}


class RoomDetailDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedTile: deviceName.heartRate,
      selectedDate: moment(),
      noDevice: false,
      graphData: {},

      // for onclick dialog
      roomEditVisible: false,
      roomEditGender: gender.male,
      roomEditPatient: '',
      roomEditBirthday: undefined,
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.selectedRoom.suiteId, this.props.selectedRoom.suiteId)) {
      this.fetchGraphData();
    }
    if (!_.isEqual(prevProps.visible, this.props.visible) && this.props.visible) {
      if(this.props.isOldData) {
        this.updateSelectedTile(deviceName.heartRateOld);
      } else {
        this.updateSelectedTile(deviceName.heartRate);
      }
    }
  }
  
  onCloseRoomDetailDialog = () => {
    const { onCancel } = this.props;
    onCancel();
  }

  fetchGraphData = () => {
    const { selectedRoom, getHistoryData } = this.props;
    const { selectedTile, selectedDate } = this.state;
    const { devices } = selectedRoom;
    const deviceObject = getDeviceData(devices, selectedTile);
    if (deviceObject) {
      this.setState({
        noDevice: false,
        graphData: {},
      }, () => {
        const fromDateString = selectedDate.format('YYYY/MM/DD');
        const toDateString = moment(fromDateString, 'YYYY/MM/DD').add(1, 'day').format('YYYY/MM/DD');
        const fromDate = new Date(fromDateString).toISOString();
        const toData = new Date(toDateString).toISOString();
        getHistoryData(fromDate, toData, deviceObject.deviceId, selectedTile);
        this.setState({
          graphData: constructGraphData(selectedTile, selectedDate),
        })
      })
    } else {
      this.setState({
        noDevice: true,
      })
    }
  }

  updateSelectedDate = date => {
    this.setState({
      selectedDate: date,
      graphData: {},
    }, this.fetchGraphData);
  }
  
  updateSelectedTile = id => {
    this.setState({
      selectedTile: id,
      graphData: {},
    }, this.fetchGraphData);
  }

  disabledEndDate = endValue => {
    const now = moment().add(1,'days').startOf('day');
    if (!endValue) {
      return false;
    }
    return now.valueOf() < endValue.valueOf();
  };

  toggleDialogVisiable = (name, visible) => {
    this.setState({
      [name]: visible,
    })
  }

  onChangePatient = event => {
    this.setState({ roomEditPatient: event.target.value });
  }

  onChangeGender = event => {
    this.setState({ roomEditGender: event.target.value });
  }

  onSaveRoomEdit = () => {
    const { selectedRoom, activeKey, updateFamilyItem, selectedFamily } = this.props;
    const { suiteId } = selectedRoom;
    const { name } = selectedFamily;
    const { roomEditGender, roomEditPatient, roomEditBirthday } = this.state;
    
    const updatedFamily = {
      name: name,
      patient: roomEditPatient,
      gender: roomEditGender,
      groupIds: selectedRoom.groupIds,
      patientBirthday: moment(roomEditBirthday).utc().format('YYYY-MM-DDTHH:mm:ssZ'),
    }
    updateFamilyItem(suiteId, updatedFamily, activeKey);
    this.toggleDialogVisiable('roomEditVisible', false);
  }

  onCancelRoomEdit = () => {
    this.setState(initialRoomEditState, () => {
      this.toggleDialogVisiable('roomEditVisible', false);
    })
  }

  renderRoomInfo = () => {
    const { selectedFamily } = this.props;
    const { name, patient, patientBirthday, gender } = selectedFamily;
    
    return (
      <div className='roomInfo flexColumn'>
        <div className='roomName flexRow header' style={styles.topDiv}>
          <div className='title'>
            { name }
          </div>
          <div className='name'>
            { patient }
          </div>
        </div>

        <div className='roomName flexRow'>
          <div className='birthday'>
            { patientBirthday && moment.utc(patientBirthday).isAfter(minDate) ? moment(patientBirthday).format('YYYY-MM-DD') : '-' }
          </div>
          <div className='age'>
            { patientBirthday && moment.utc(patientBirthday).isAfter(minDate)  ? `${moment().diff(moment(patientBirthday), 'years')}${roomDetailDialogStrings.ageUnit}` : '-' }
          </div>
          <div className='sex'>
            { genderText[gender] }
          </div>
        </div>

        <div>
          <Button
            className='floatRight'
            onClick={() => {
              this.setState({
                roomEditGender: gender,
                roomEditPatient: patient,
                roomEditBirthday: patientBirthday && moment.utc(patientBirthday).isAfter(minDate) ? moment(patientBirthday) : undefined,
                roomEditVisible: true,
              });
            }}
          >
            { roomDetailDialogStrings.edit }
          </Button>
        </div>
      </div>
    )
  }

  renderButtonSet = () => {
    const { displayData, isOldData } = this.props;
    const { selectedTile } = this.state;
    const {
      heartRateText, breathText, washroomText, doorText,
      heartRateOffline, breathOffline, washroomOffline, doorOffline,
    } = displayData;
    return (
      <div className='roomButtonSet'>
        <ButtonTile
          id={isOldData ? deviceName.heartRateOld : deviceName.heartRate}
          isSelected={selectedTile === deviceName.heartRateOld || selectedTile === deviceName.heartRate}
          title={roomDetailDialogStrings.heartRate}
          data={heartRateText}
          backgroundColor={'#FF8CA0'}
          onPress={this.updateSelectedTile}
          position={'topLeft'}
          deviceOffline={heartRateOffline}
        />
        <ButtonTile
          id={isOldData ? deviceName.breathOld : deviceName.breath}
          isSelected={selectedTile === deviceName.breathOld || selectedTile === deviceName.breath}
          title={roomDetailDialogStrings.breath}
          data={breathText}
          backgroundColor={'#F5A04A'}
          onPress={this.updateSelectedTile}
          position={'topRight'}
          deviceOffline={breathOffline}
        />
        <ButtonTile
          id={deviceName.pirDetect}
          isSelected={selectedTile === deviceName.pirDetect}
          title={roomDetailDialogStrings.washroom}
          data={washroomText}
          backgroundColor={'#FFD72C'}
          onPress={this.updateSelectedTile}
          position={'botLeft'}
          deviceOffline={washroomOffline}
        />
        <ButtonTile
          id={deviceName.door}
          isSelected={selectedTile === deviceName.door}
          title={roomDetailDialogStrings.door}
          data={doorText}
          backgroundColor={'#78C878'}
          onPress={this.updateSelectedTile}
          position={'botRight'}
          deviceOffline={doorOffline}
        />
      </div>
    )
  }

  renderRoomStatus = () => {
    const { displayData } = this.props;
    const {
      temperatureText,
      humidityText,
      indoorText,
      lightText,
      temperatureOffline,
      humidityOffline,
      indoorOffline,
      lightOffline,
    } = displayData;
    return (
      <div className='roomStatus'>
        <InfoTile
          title={roomDetailDialogStrings.temperature}
          data={temperatureText}
          deviceOffline={temperatureOffline}
        />
        <InfoTile
          title={roomDetailDialogStrings.humidity}
          data={humidityText}
          deviceOffline={humidityOffline}
        />
        <InfoTile
          title={roomDetailDialogStrings.presence}
          data={indoorText}
          deviceOffline={indoorOffline}
        />
        <InfoTile
          title={roomDetailDialogStrings.lightLevel}
          data={lightText}
          deviceOffline={lightOffline}
        />
      </div>
    )
  }

  renderGraphDateSelector = () => {
    const { selectedTile, selectedDate } = this.state;
    const graphTitle = getGraphTitle(selectedTile);
    return (
      <div className='flexRow titleRow flexAlignCenter'>
        <div className='title'>
          { graphTitle }
        </div>
        <DatePicker
          disabledDate={this.disabledEndDate}
          onChange={this.updateSelectedDate}
          size='small'
          value={selectedDate}
          allowClear={false}
          defaultValue={moment()}
        />
      </div>
    )
  }

  renderGraphTile = (data, selectedTile, selectedDate, graphData) => {
    const finalGraphData = constructFinalData(data, selectedTile, selectedDate, graphData);
    switch (selectedTile) {
      case deviceName.heartRate:
      case deviceName.breath:
      case deviceName.heartRateOld:
      case deviceName.breathOld:
        return (
          <Line
            data={finalGraphData.data}
            options={finalGraphData.options}
            width={760}
            height={580}
            plugins={[lineChartPlugin]}
          />
        );
      case deviceName.pirDetect:
      case deviceName.door:
        return (
          <Scatter
            data={finalGraphData.data}
            options={finalGraphData.options}
            width={760}
            height={580}
            plugins={[scatterChartPlugin]}
          />
        );
      default:
        return null;
    }
  }

  renderGraph = () => {
    const { isLoading, data } = this.props;
    const { noDevice, selectedTile, selectedDate, graphData } = this.state;
    if (noDevice) {
      return (
        <div style={styles.nullScreenContainer}>
          { roomItemStrings.deviceNull }
        </div>
      )
    }
    return (
      <div style={styles.nullScreenContainer}>
        {
          isLoading || !(selectedTile && selectedDate) ? 
          <FadeLoader
            loading={isLoading}
            color={'#D2D2D2'}
          /> :
          this.renderGraphTile(data, selectedTile, selectedDate, graphData)
        }
      </div>
    )
  }

  renderRoomEditDialog = () => {
    const {
      // redirect, redirectID,
      roomEditVisible, roomEditBirthday,
      roomEditPatient, roomEditGender,
    } = this.state;
    const title = (
      <div className='roomEditDialogTitle'>
      </div>
    );
    const foorter = (
      <div className='dialogFooter'>
        <Button className='footerSaveButtin' onClick={this.onSaveRoomEdit}>
          {roomEditDialogStrings.confirmButton}
        </Button>
        <Button className='footerCancelButton' onClick={this.onCancelRoomEdit}>
          {roomEditDialogStrings.cancelButton}
        </Button>
      </div>
    );

    return (
        <Modal
          style={styles.roomEditDialog}
          centered
          visible={roomEditVisible}
          maskClosable={false}
          title={title}
          footer={foorter}
          onCancel={() => this.onCancelRoomEdit()}
        >
          <div className={'roomEditPatientInputContainer'}>
            <span>{roomEditDialogStrings.nameTitle}</span>
            <Input value={roomEditPatient} onChange={this.onChangePatient} />
          </div>
          <div className={'roomEditPatientGenderContainer'}>
            <span>{roomEditDialogStrings.sex}</span>
            <Radio.Group name="radiogroup" onChange={this.onChangeGender} value={roomEditGender}>
              <Radio value={gender.male}>{roomEditDialogStrings.male}</Radio>
              <Radio value={gender.female}>{roomEditDialogStrings.female}</Radio>
            </Radio.Group>
          </div>
          <div className={'roomEditPatientBirthdayContainer'}>
            <span>{roomEditDialogStrings.birthdayTitle}</span>
            <DatePicker
              disabledDate={this.disabledEndDate}
              onChange={(x) => {
                this.setState({
                  roomEditBirthday: x,
                })
              }}
              size='small'
              value={roomEditBirthday}
              allowClear={false}
              defaultPickerValue={null}
            />
          </div>
        </Modal>
      )
  }

  render() {
    const { visible, selectedRoom } = this.props;

    const title = (
      <div className='dialogTitle'>
      { roomDetailDialogStrings.title }
      </div>
    )
    const foorter = (
      <div>
      </div>
    )

    return (
      <Modal
        style={styles.roomDetailDialog}
        centered
        width={1300}
        visible={visible}
        maskClosable={true}
        title={title}
        destroyOnClose={true}
        footer={foorter}
        onCancel={() => this.onCloseRoomDetailDialog()}
        wrapClassName={'dialog-roomDetail'}
      >
        <div className='roomDetailDialogMain'>
          <div className='infoContainer'>
            { selectedRoom && this.renderRoomInfo() }
            { selectedRoom && this.renderButtonSet() }
            { selectedRoom && this.renderRoomStatus() }
          </div>
          <div className='graphContainer'>
            { selectedRoom && this.renderGraphDateSelector() }
            { visible && selectedRoom && this.renderGraph() }
          </div>
        </div>
        { this.renderRoomEditDialog() }
      </Modal>
    );
  }
}

RoomDetailDialog.defaultProps = {
};

RoomDetailDialog.propTypes = {
  roomEditID: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { roomDetailReducer } = state;
  const {
    currentFamilies,
  } = state.groupListReducer;
  const {
    families,
  } = state.notificationListReducer;
  const selectedRoom = _.find(currentFamilies, (family) => family.suiteId === ownProps.roomEditID) || {};
  const selectedFamily = _.get(families, `[${ownProps.roomEditID}]`, {});
  const { devices } = selectedRoom;
  const displayData = constructRoomDetailStatus(devices);
  return {
    ...roomDetailReducer,
    selectedRoom,
    displayData,
    selectedFamily,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getHistoryData,
      updateFamilyItem,
    },
    dispatch,
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(RoomDetailDialog);
